import { API_URLS } from "../../../Configs/apiUrls";
import axiosInstance from "../../../Configs/axios";

export const cityBasedWarehouseFn = (redBody) => {
  try {
    const response = axiosInstance.post(API_URLS.cityBasedWarehouse, redBody);
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};
